import { Injectable } from '@angular/core';
import {
 
  LoginSMSOTPRequestData,
} from '../../module/general/pages/login/login.component';
import { PostRequestBase, ResponseBase , RequestData, ResponseData,} from '../models/common';

import { GlobalsService } from './globals.service';
import {
  DocusignStatusResponse,
  GlobalDataResponse,
  LoginSMSOTPResponse,
  SubmitFNACompletionResponse,
} from '../models/fna';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  
  constructor(private globals: GlobalsService) {}

  // Helper function to simulate a delay
  async delay(milliseconds: number) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  // Simulate a short delay for API request
  async mockShortDelay() {
    await this.delay(400);
  }

  // API to retrieve data for a screen
  // Called when new screen is loaded.
  async retrieveFNAInfo(screenName: string): Promise<ResponseBase> {
    await this.mockShortDelay();

    let response = await import(
      `../../../mock-data/RetrieveFNAInfo/ScreenName-${screenName}.json`
    );
    response = JSON.parse(JSON.stringify(response)).default as ResponseBase;

    console.log('[retrieveFNAInfo]', response);
    if (this.globals.mockedDeclaredRisk) {
      if (typeof response.DeclaredRiskProfile !== 'undefined') {
        response.DeclaredRiskProfile =
          this.globals.mockedDeclaredRisk.toString();
      }
    }

    if (this.globals.mockedAssessedRisk) {
      if (typeof response.AssessedRiskProfile !== 'undefined') {
        response.AssessedRiskProfile =
          this.globals.mockedAssessedRisk.toString();
      }
    }

    if (typeof response.HasReadTermsAndConditions !== 'undefined') {
      response.HasReadTermsAndConditions =
        this.globals.mockHasReadTermsAndConditions;
    }

    if (typeof response.HasReadPurposeOfFormModal !== 'undefined') {
      response.HasReadPurposeOfFormModal =
        this.globals.mockHasReadPurposeOfFormModal;
    }

    if (
      typeof response.IsAcceptRecommendedProducts !== 'undefined' &&
      screenName === 'NonRecommendedProducts'
    ) {
      response.IsAcceptRecommendedProducts =
        this.globals.mockIsAcceptRecommendedProducts;
    }

    if (
      typeof response.IsAcceptAssessedRiskProfile !== 'undefined' &&
      screenName === 'NonRecommendedProducts'
    ) {
      response.IsAcceptAssessedRiskProfile =
        this.globals.mockIsAcceptAssessedRiskProfile;
    }

    console.log('[debug] response:', response);

    return response;
  }

  // API to submit data
  // Called when user click next or save as draft
  async submitFNAInfo(data: PostRequestBase | any): Promise<boolean> {
    // @For integration.
    await this.mockShortDelay();

    if (this.globals.simulateServerBehaviour) {
      // Mock update lastSavedTime.
      // In production, backend will return lastSavedTime in the response data
      // and frontend will update to the globals.model.lastSavedTime
      this.globals.model.lastSavedTime = new Date().toISOString();
    }

    return true;
  }

  // API for login
  async read(data: RequestData | any): Promise<ResponseData> {
    // @For integration to log the user in.

    try {
      this.globals.showLoader();
      const config = {
        method: 'POST',
        headers : {
          'Accept' : 'application/json;charset=utf-8',
          'Content-Type' : 'application/json;charset=utf-8',
          
          
        },
        body:JSON.stringify(data)
      };
      const fetchResponse = await fetch('./prservices/readService',config)
      const resp:ResponseData = await fetchResponse.text().then(function(text){
       
      let tempString = text.replace('\t{pr}','')
       let tempStringTwo =  tempString.split('\t').join('').split('\n').join('');
       //let tempStringTwothree = tempString.split(/[:"].*[",]/).join(':\" \",')
      console.log("TEMP TEMP")
      console.log(tempStringTwo.charAt(0))
      
      let jsonResp =  JSON.parse(tempStringTwo)
       console.log(jsonResp)
       return jsonResp;
      })
  
      //const resp:Responsedata = await fetchResponse.json();
     
      return resp;
    
     
    } catch (ex) {
      // Handle different exception here and constructs a friendly message to be displayed to the user.
      throw new Error(
        'An unexpected error has occurred. Please contact OCBC staff for assistance.',
      );
    } finally {
      this.globals.hideLoader();
    }

   
  }

   // API to submit completed form
   async submitFNACompletion(
    data: PostRequestBase | any,
  ): Promise<SubmitFNACompletionResponse> {
    // @For integration.
    await this.mockShortDelay();

    if (this.globals.simulateServerBehaviour) {
      // Mock update LastSavedTime.
      // In production, backend will return LastSavedTime in the response data
      // and frontend will update to the globals.model.LastSavedTime
      this.globals.model.LastSavedTime = new Date().toISOString();
    }

    return {
      Status: true,
      DocuSignURL: 'https://www.ocbc.com',
    };
  }

  async getGlobalData(
    data: PostRequestBase | any,
  ): Promise<GlobalDataResponse> {
    // @For integration to get global data
    try {
      this.globals.showLoader();

      // Make API request to backend
      // @TODO: replace mocking short delay with actual API request to backend
      await this.mockShortDelay();

      // Uncomment this line to simulate an error
      // throw new Error('Simulate resendLoginSMSOTP error');

      let response = await import(
        `../../../mock-data/RetrieveFNAInfo/GlobalData.json`
      );
      return JSON.parse(JSON.stringify(response)).default as GlobalDataResponse;
    } catch (ex) {
      // Handle different exception here and constructs a friendly message to be displayed to the user.
      throw new Error(
        'An unexpected error has occurred. Please contact OCBC staff for assistance.',
      );
    } finally {
      this.globals.hideLoader();
    }
  }
  // API for login
  async save(data: RequestData | any): Promise<ResponseData> {
    // @For integration to log the user in.
    try {
    const config = {
      method: 'POST',
      headers : {
        'Accept' : 'application/json;charset=utf-8',
        'Content-Type' : 'application/json;charset=utf-8',
        
        
      },
      body:JSON.stringify(data)
    };
    const fetchResponse = await fetch('./prservices/writeService',config)
    const resp:ResponseData = await fetchResponse.text().then(function(text){
      
    let tempString = text.replace('\t{pr}','')
    let tempStringTwo =  tempString.split('\t').join('').split('\n').join('');
    console.log("AFTER INITIAL FILTER");
    console.log(tempStringTwo)
    let jsonResp = JSON.parse(tempStringTwo);

     console.log(jsonResp)
     return jsonResp;
    })

    //const resp:Responsedata = await fetchResponse.json();
   
    return resp;

  } catch (ex) {
    // Handle different exception here and constructs a friendly message to be displayed to the user.
    throw new Error(
      'An unexpected error has occurred. Please contact OCBC staff for assistance.',
    );
  } finally {
    this.globals.hideLoader();
  }
  
  }

   // API to poll for docusign status
   async pollingDocusignStatus(): Promise<DocusignStatusResponse> {
    // @For integration.
    // Backend to update status to 'Complete' after timeout, should not be longer than 1 minute

    await this.delay(2000);

    return {
      Status: 'Complete',
    };
  }

  async staticData(data: RequestData | any): Promise<ResponseData> {
    // @For integration to log the user in.
    try {
      this.globals.showLoader();
      const config = {
        method: 'POST',
        headers : {
          'Accept' : 'application/json;charset=utf-8',
          'Content-Type' : 'application/json;charset=utf-8',
          
          
        },
        body:JSON.stringify(data)
      };
      const fetchResponse = await fetch('./prservices/staticDataService',config)
      const resp:ResponseData = await fetchResponse.text().then(function(text){
        console.log
      //let tempString = text.replace('\t','')
      let tempString = text.split('\t').join('');
      let jsonResp = JSON.parse(tempString)
       console.log(jsonResp)
       return jsonResp;
      })
  
      //const resp:Responsedata = await fetchResponse.json();
     
      return resp;
    

    } catch (ex) {
      // Handle different exception here and constructs a friendly message to be displayed to the user.
      console.log(ex)
      throw new Error(
        'An unexpected error has occurred. Please contact OCBC staff for assistance.',
      );
    } finally {
      this.globals.hideLoader();
    }
   
  }

  async BVLoginData(data: RequestData | any): Promise<any> {
    // @For integration to log the user in.

    try {
    this.globals.showLoader();
    const config = {
      method: 'POST',
      headers : {
        'Accept' : 'application/json;charset=utf-8',
        'Content-Type' : 'application/json;charset=utf-8',
        
        
      },
      body:JSON.stringify(data)
    };
    const fetchResponse = await fetch('./prservices/BVLoginService',config)
    const resp:any = await fetchResponse.text().then(function(text){
      console.log
    //let tempString = text.replace('\t','')
    //let tempString = text.split('\t').join('');
    let jsonResp = JSON.parse(text)
     console.log(jsonResp)
     return jsonResp;
    })

    //const resp:Responsedata = await fetchResponse.json();
   
    return resp;

  } catch (ex) {
    // Handle different exception here and constructs a friendly message to be displayed to the user.
    throw new Error(
      'An unexpected error has occurred. Please contact OCBC staff for assistance.',
    );
  } finally {
    this.globals.hideLoader();
  }
  
  }


  // API for logout
  async logout(data: PostRequestBase | any) {
    // @For integration to log the user out.

    await this.mockShortDelay();
  }

  // API for submit SMS OTP for verification
  async submitLoginSMSOTP(
    data: RequestData | any,
  ): Promise<LoginSMSOTPResponse> {
    // @For integration to check if OTP is valid.

    await this.mockShortDelay();

    return {
      Status: true,
      LastVisitedScreenName: '',
    };
  }

  // API to trigger resend SMS OTP
  async resendLoginSMSOTP(data: PostRequestBase | any): Promise<boolean> {
    // @For integration to resend OTP upon expiry.

    // @TODO: Do we pass an ID/token that can identify the user so that backend know which user to resend SMS OTP?

    await this.mockShortDelay();

    return true;
  }

  getTokenID(){
    let tokenID = localStorage.getItem('DFNA-tokenID');
    let extraChars = "\t{pr}"
    let finalTokenID =extraChars.concat(tokenID+"")
    return finalTokenID;
  }
}
